import Axios from '../Axios';

const city = {
	create(data) {
		return Axios.post('/cities', data);
	},
	read(limit = 10, page = 1, search) {
		return Axios.get('/cities?limit=' + limit + '&page=' + page + search);
	},
	readOne(id) {
		return Axios.get('/cities/' + id);
	},
	update(id, data) {
		return Axios.put('/cities/' + id, data);
	},
	delete(id) {
		return Axios.delete('/cities/' + id);
	},
};

export default city;
